if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      if($('#vin-text-box').length){
        var vinInputValueCheck = $('#vin-text-box').val();
        $(".vin-text-box-value").val(vinInputValueCheck);
        var alphanumericRegex = /^[a-zA-Z0-9]+$/;
  
        if (vinInputValueCheck.trim() != '' && vinInputValueCheck.length == 17 && alphanumericRegex.test(vinInputValueCheck)) {
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
          this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        }
      }
      
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      var AddtoCart = false;
      if($('#vin-text-box').length){

        if(vinInputValueCheck.length !== 17 || !alphanumericRegex.test(vinInputValueCheck)) {
          $(".vin-val__error-massage span").text("Please enter a valid VIN with a length of 17 characters.");
        }else{
          $(".vin-val__error-massage span").text(" ");
        }
        if(vinInputValueCheck.trim() === ''){
          $(".vin-val__error-massage span").text("This VIN Field is Required");
        }
        
        if (vinInputValueCheck.trim() != '' && vinInputValueCheck.length == 17 && alphanumericRegex.test(vinInputValueCheck)) {
          AddtoCart = true;
        }
      }else{
        AddtoCart = true;
      }
      
      if(AddtoCart){
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
  
            this.cartNotification.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove('loading');
            submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            $('.cart-notification').removeClass('active');
            window.location.href="/cart";
          });
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
$("#vin-text-box").on("keydown keyup change", function(e) {
    var $val = $(this).val();
    $(this).val($val.toUpperCase());
})